import { Stage } from '../types/types';

/**
 * The stage a candidate would normally move to next: the stage's configured
 * AdvanceToStage if it's active, otherwise the next active stage by display order.
 * "Move from any stage" stages (e.g. Rejected) are never picked by display order.
 */
export const getNextStage = (stages: Stage[], currentStageId: string): Stage | undefined => {
    const activeStages = stages
        .filter(s => s.isActive)
        .sort((a, b) => a.displayOrder - b.displayOrder);

    const currentStage = stages.find(s => s.id === currentStageId);
    if (!currentStage) return undefined;

    if (currentStage.advanceToStageId) {
        const configured = activeStages.find(s => s.id === currentStage.advanceToStageId);
        if (configured) return configured;
    }

    return activeStages.find(s =>
        s.displayOrder > currentStage.displayOrder &&
        s.id !== currentStageId &&
        !s.canMoveToFromAnyStage);
};
